import request from'@/utils/request.js'

export default{
    Query(data) {
        return request({
            url: '/Banner/Query',
            method: 'post',
            data
        })
    }    
} 